export class StorageHelper {
  static set(key: string, value: any, expirationDays?: number): void {
    const item = {
      value,
      timestamp: expirationDays ? new Date().getTime() + expirationDays * 24 * 60 * 60 * 1000 : null
    };

    localStorage.setItem(key, JSON.stringify(item));
  }

  static get(key: string): any | null {
    const item = localStorage.getItem(key);

    if (!item) {
      return null;
    }

    const parsedItem = JSON.parse(item);

    if (parsedItem.timestamp && new Date().getTime() > parsedItem.timestamp) {
      this.remove(key);
      return null;
    }

    return parsedItem.value;
  }

  static remove(key: string): void {
    localStorage.removeItem(key);
  }

  static exists(key: string): boolean {
    return this.get(key) !== null;
  }

  static clear(): void {
    localStorage.clear();
  }
}
